import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { PageWrapper } from "components/ui/PageWrapper";
import { FormInput } from "components/ui/FormInput";
import { AltTextField } from "components/ui/AltTextField";
import { ButtonLoader } from "components/Loader/ButtonLoader";
import { GetCarbohydrateBanner } from "rest/complexCarbohydrate";
import { TextEditor } from "components/ui/TextEditor";
import { CreateCarbohydrateBanner } from "rest/complexCarbohydrate";
import { ComponentLoader } from "components/Loader/ComponentLoader";
import { ErrorComponent } from "components/Alerts/Error";

export default function CarbohydrateBanner() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm();

  const getBanner = GetCarbohydrateBanner();
  const createBanner = CreateCarbohydrateBanner();
  const [perviewImages, setPreviewImages] = useState("");
  const [defaultImg, setDefaultImg] = useState("");

  const handleChange = (e) => {
    const files = e.target.files[0];
    if (files) {
      const imageUrl = URL.createObjectURL(files);
      setPreviewImages(imageUrl);
    }
  };

  useEffect(() => {
    const defaultValues = {};
    defaultValues.heading = getBanner?.data?.data?.heading;
    defaultValues.sub_heading = getBanner?.data?.data?.sub_heading;
    defaultValues.description = getBanner?.data?.data?.description;
    defaultValues.what_is_heading = getBanner?.data?.data?.what_is_heading;
    defaultValues.what_is_answer = getBanner?.data?.data?.what_is_answer;
    setDefaultImg(getBanner?.data?.data?.image);
    defaultValues.bannerImageAlt = getBanner?.data?.data?.image_alt || "";
    reset(defaultValues);
  }, [getBanner?.data?.data]);

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("heading", data?.heading);
    formData.append("sub_heading", data?.sub_heading || "");
    formData.append("description", data?.description);
    formData.append("what_is_heading", data?.what_is_heading || "");
    formData.append("what_is_answer", data?.what_is_answer || "");
    formData.append("image", data?.bannerImage[0]);
    formData.append("image_alt", data?.bannerImageAlt || "");
    createBanner.mutate(formData);
  };
  return (
    <>
      <PageWrapper slug="carbohydrate-banner" name="Carbohydrate Banner" />
      {getBanner?.isError && (
        <ErrorComponent message="OOPS ! something went wrong please try again later" />
      )}
      {getBanner?.isPending ? (
        <ComponentLoader />
      ) : (
        <div className="home_banner_input">
          <form onSubmit={handleSubmit(onSubmit)} className="row mt-4 mb-3">
            <div className="mb-3 col-md-6">
              <label htmlFor="mainHeading" className="form-label">
                Main Heading
              </label>
              <FormInput
                type="text"
                name="heading"
                placeholder="heading"
                {...register("heading", { required: true })}
              />
              {errors?.heading && (
                <p className="errorMessage">Heading is required</p>
              )}
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="sub_heading" className="form-label">
                Sub Heading
              </label>
              <FormInput
                type="text"
                name="sub_heading"
                placeholder="sub heading"
                {...register("sub_heading")}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label htmlFor="bannerImage" className="form-label">
                Banner Image (1540px * 305px)
              </label>
              <FormInput
                type="file"
                name="bannerImage"
                placeholder="bannerImage"
                {...register("bannerImage", {
                  required: !perviewImages && !defaultImg,
                  onChange: (e) => handleChange(e),
                })}
              />
              {errors?.bannerImage && (
                <p className="errorMessage">Field is required</p>
              )}
              {perviewImages && (
                <img
                  src={perviewImages}
                  alt=" banner Preview"
                  style={{ maxWidth: "300px", marginTop: "10px" }}
                />
              )}
              {!perviewImages && defaultImg && (
                <img
                  src={defaultImg}
                  alt="banner Preview"
                  style={{ maxWidth: "300px", marginTop: "10px" }}
                />
              )}
            </div>
            <AltTextField
              register={register}
              name="bannerImageAlt"
              label="Banner Alt Text"
            />
            <div className="mb-4 col-12">
              <label htmlFor={`description`} className="form-label">
                Bottom Description
              </label>
              <TextEditor
                control={control}
                name={`description`}
                defaultValue={getBanner?.data?.data?.description}
                {...register(`description`, {
                  required: true,
                })}
              />
              {errors.description && (
                <p className="errorMessage">Description is required</p>
              )}
            </div>

            <div className="col-12">
              <hr className="my-4" />
              <h5 className="fw-bold mb-3">
                "What is Custom Carbohydrate Synthesis?" Section
              </h5>
            </div>

            <div className="mb-3 col-md-12">
              <label htmlFor="what_is_heading" className="form-label">
                Heading
              </label>
              <FormInput
                type="text"
                name="what_is_heading"
                placeholder="What is Custom Carbohydrate Synthesis?"
                {...register("what_is_heading")}
              />
            </div>
            <div className="mb-4 col-12">
              <label htmlFor="what_is_answer" className="form-label">
                Answer
              </label>
              <TextEditor
                control={control}
                name="what_is_answer"
                defaultValue={getBanner?.data?.data?.what_is_answer}
                {...register("what_is_answer")}
              />
            </div>

            {createBanner?.isPending ? (
              <div>
                <ButtonLoader />
              </div>
            ) : (
              <div className="mb-3 col-12">
                <input type="submit" value="submit" className="input_submit" />
              </div>
            )}
          </form>
        </div>
      )}
    </>
  );
}
